<div class="state-dot" [ngClass]="color" [attr.style]="dotStyle"></div>
